import { render, staticRenderFns } from "./choose-group.vue?vue&type=template&id=c0dab5fe&"
import script from "./choose-group.vue?vue&type=script&lang=ts&"
export * from "./choose-group.vue?vue&type=script&lang=ts&"
import style0 from "./choose-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports